import { useEffect, useRef, useState } from 'react';
import { useAuth } from '@/store/AuthContext';
import { Icon } from '@/components/Icon';

/** Botón de usuario: solo el icono en la cabecera. Al pulsarlo se despliega
 *  el email y el botón de cerrar sesión (así no se muestra el correo a la
 *  vista y cerrar sesión es un segundo clic deliberado). */
export function UserMenu() {
  const { user, signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="ld-menu" ref={wrapRef}>
      <button
        type="button"
        className={`ld-icon-btn${open ? ' active' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Cuenta y cerrar sesión"
        title="Cuenta"
      >
        <Icon name="logout" size={20} />
      </button>
      {open ? (
        <div className="ld-menu__panel ld-usermenu" role="menu">
          <span className="ld-usermenu__email">{user?.email}</span>
          <button type="button" className="ld-btn ld-btn--ghost ld-btn--small" onClick={signOut}>
            Cerrar sesión
          </button>
        </div>
      ) : null}
    </div>
  );
}
